// extracted by mini-css-extract-plugin
export default {"forecastContainer":"forecast_forecastContainer__aECbB"};